import { useMemo } from 'react';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';
import { useQueryParamValue } from 'src/app/shared/hooks/location';

type Result = ModelHookResult<{
	states: ReadonlyArray<{
		name: string;
		value: unknown;
	}>;
}>;

export function usePageState(): Result {
	const {
		data: { petition, recruiter },
	} = usePsfPromoteOrSharePageData();
	const guest = useQueryParamValue('guest');

	return {
		data: {
			states: useMemo(() => {
				return [
					{
						name: 'petition',
						value: {
							id: petition.id,
							user: { id: petition.user.id },
							createdAt: petition.createdAt,
							geoReach: petition.geoReach,
							relevantLocationLocalizedName: petition.relevantLocationLocalizedName,
							signatureCount: {
								total: petition.signatureState.signatureCount.total,
								displayed: petition.signatureState.signatureCount.displayed,
								goal: petition.signatureState.signatureGoal.displayed,
							},
							weeklySignatureCount: petition.weeklySignatureCount,
							lowMonetization: !!petition.petitionTargeting?.lowMonetization,
							promotionStats: {
								signaturesFromPromotions: petition.promotionStats.signatureCount,
								promoterCount: petition.promotionStats.promoterCount,
							},
						},
					},
					{ name: 'guestUserState', value: guest },
					...(recruiter
						? [
								{
									name: 'recruiter',
									value: {
										id: recruiter.id,
										displayName: recruiter.displayName,
									},
								},
							]
						: []),
				];
			}, [petition, guest, recruiter]),
		},
	};
}
